import { render, staticRenderFns } from "./NewChatMessageEvent.vue?vue&type=template&id=5e39c65e"
import script from "./NewChatMessageEvent.vue?vue&type=script&lang=js"
export * from "./NewChatMessageEvent.vue?vue&type=script&lang=js"
import style0 from "./NewChatMessageEvent.vue?vue&type=style&index=0&id=5e39c65e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports